module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1054-914245f2c5ce51a5ae90a13500b6f935.png";